import { FormItem, FormRow } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import styles from './ApplyTrialBox.module.less'
import { observer } from 'mobx-react-lite'
import AInput from '../A/AInput/AInput'
import AButton from '../A/AButton/AButton'
import AIcon from '../A/AIcon/AIcon'
import DefaultAvatar from '../DefaultAvatar/DefaultAvatar'
import cls from 'classnames'
import DropdownSelector from './components/DropdownSelector/DropdownSelector'
import { useEffect, useState } from 'react'
import TRANSLATION from '@/i18n/locales/zh/translation'
import useTrialOptions from '@/helpers/commonHooks/useTrialOptions'
import { useTranslation } from 'react-i18next'

export interface ApplyTrialParam {
  staffName: string,
  staffTel: string
  // 部门
  staffDepartment: string
  //职位
  staffPosition: string
  // 企业名称
  corpName: string,

  country: string
  city: string
}

interface Props {
  userInfo: Models.UserInfo
  onSubmit: (param: ApplyTrialParam) => void
  className?: string
}

interface Opt {
  label: string
  value: string
}


function ApplyTrialBox(props: Props) {
  const { t } = useTranslation()
  const {
    // CountryEnum,
    DEPARTMENT_OPTIONS,
    // COUNTRY_OPTIONS,
    ROLE_OPTIONS,
    DepartmentEnum,
    RoleEnum,
  } = useTrialOptions()
  const [name, setName] = useState<string | undefined>(undefined)
  const [tel, setTel] = useState<string | undefined>(undefined)
  const [department, setDepartment] = useState<Opt | undefined>(undefined)
  const [role, setRole] = useState<Opt | undefined>(undefined)
  // const [country, setCountry] = useState<Opt | undefined>(undefined)
  // const [city, setCity] = useState<string | undefined>(undefined)
  const [formError, setFromError] = useState([
    { key: 'name', error: false, msg: '' },
    { key: 'tel', error: false, msg: '' },
    { key: 'department', error: false, msg: '' },
    { key: 'role', error: false, msg: '' },
    { key: 'country', error: false, msg: '' },
    { key: 'city', error: false, msg: '' },
  ])

  const validate = (force: boolean = false) => {
    const validateError = formError
    const nameError = (force: boolean) => {
      const error = force ? !name : name === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const telError = (force: boolean) => {
      const error = force ? !tel : tel === ''
      // 校验手机号格式，支持中国和国外手机号
      // 中国手机号：11位数字，国外手机号：允许数字、+、-、空格，长度4-20
      if (!error && tel) {
        // 国外手机号校验
        if (!/^[\d+\-\s]{4,20}$/.test(tel)) {
          return { error: true, msg: t('modals.freeTrialModal.applyBox.pleaseEnterValidTel') }
        }
      }
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const departmentError = (force: boolean) => {
      const error = force ? (!department || department?.label === '') : department?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const roleError = (force: boolean) => {
      const error = force ? (!role || role?.label === '') : role?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    // const countryError = (force: boolean) => {
    //   const error = force ? (!country || country?.label === '') : country?.label === ''
    //   return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    // }
    // const cityError = (force: boolean) => {
    //   const error = force ? (!city || city === '') : city === ''
    //   return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    // }
    const index1 = validateError.findIndex(e => e.key === 'name')
    validateError[index1].error = nameError(force).error
    validateError[index1].msg = nameError(force).msg
    const index2 = validateError.findIndex(e => e.key === 'tel')
    validateError[index2].error = telError(force).error
    validateError[index2].msg = telError(force).msg
    const index3 = validateError.findIndex(e => e.key === 'department')
    validateError[index3].error = departmentError(force).error
    validateError[index3].msg = departmentError(force).msg
    const index4 = validateError.findIndex(e => e.key === 'role')
    validateError[index4].error = roleError(force).error
    validateError[index4].msg = roleError(force).msg
    // const index5 = validateError.findIndex(e => e.key === 'country')
    // validateError[index5].error = countryError(force).error
    // validateError[index5].msg = countryError(force).msg
    // const index6 = validateError.findIndex(e => e.key === 'city')
    // validateError[index6].error = country?.value === CountryEnum.China ? cityError(force).error : false
    // validateError[index6].msg = country?.value === CountryEnum.China ? cityError(force).msg : ''
    return [...validateError]
  }

  const handleSubmit = () => {
    const validateError = validate(true)
    setFromError(validateError)
    const allPass = validateError.every(e => !e.error)
    if (allPass) {
      const positionKeyIsOther = role!.value === RoleEnum.Other
      const _position = positionKeyIsOther ? role!.label : (TRANSLATION as any).modals.freeTrialModal.role[role?.value || '']
      const departmentIsOther = department!.value === DepartmentEnum.Other
      const _department = departmentIsOther ? department!.label : (TRANSLATION as any).modals.freeTrialModal.department[department?.value || '']
      props.onSubmit({
        staffName: name || '',
        staffTel: tel || '',
        staffDepartment: _department,
        staffPosition: _position,
        corpName: props.userInfo.corpName || '',
        /** 因为后端要中文，但是前端 label 是多语言，因此通过中文语言文件转译一下 */
        // country: (TRANSLATION as any).modals.freeTrialModal.country[country?.value || ''],
        // city: city || '',
        country: '',
        city: '',
      })
    }
  }


  useEffect(() => {
    const validateError = validate()
    setFromError(validateError)
  }, [name, tel, department, role,
    // country, city
  ])


  return <div className={cls(styles.applyTrialBox, props.className)}>
    <div className={styles.trialAccountBox}>
      <div className={styles.trialAccount}>
        <DefaultAvatar name={props.userInfo.name} avatar={props.userInfo.avatar} />
        <div className={styles.accountDesc}>
          <div className={styles.accountName}>
            <span>{props.userInfo.name}</span>
            <span className={styles.corpName}>{props.userInfo.corpName}</span>
          </div>
          <p className={styles.accountEmail}>{props.userInfo.email}</p>
        </div>
      </div>
    </div>
    <div className={styles.formBox}>
      <FormRow>
        <FormItem required label={t('modals.freeTrialModal.applyBox.name')}
          error={formError.find(e => e.key === 'name')?.error} errorMsg={formError.find(e => e.key === 'name')?.msg}>
          <AInput testId='free-trial-name-input' placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheName')} value={name} onChange={e => {
            setName(e.target.value)
          }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required label={t('modals.freeTrialModal.applyBox.tel')} error={formError.find(e => e.key === 'tel')?.error} errorMsg={formError.find(e => e.key === 'tel')?.msg}>
          <AInput testId='free-trial-tel-input' placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheTel')} value={tel} onChange={e => {
            setTel(e.target.value)
          }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required label={t('modals.freeTrialModal.applyBox.department')} error={formError.find(e => e.key === 'department')?.error} errorMsg={formError.find(e => e.key === 'department')?.msg}>
          <DropdownSelector testId='free-trial-department-selector' options={DEPARTMENT_OPTIONS} otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')} placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheDepartment')} onChange={opt => {
            setDepartment(opt)
          }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required label={t('modals.freeTrialModal.applyBox.role')} error={formError.find(e => e.key === 'role')?.error} errorMsg={formError.find(e => e.key === 'role')?.msg}>
          <DropdownSelector testId='free-trial-role-selector' options={ROLE_OPTIONS} otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')} placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheRole')}
            onChange={opt => {
              setRole(opt)
            }}
          />
        </FormItem>
      </FormRow>
      {/* <FormRow>
        <FormItem required label={t('modals.freeTrialModal.applyBox.country')} error={formError.find(e => e.key === 'country')?.error} errorMsg={formError.find(e => e.key === 'country')?.msg}>
          <DropdownSelector testId='free-trial-country-selector' options={COUNTRY_OPTIONS} otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')} placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheCountry')} onChange={opt => {
            setCountry(opt)
          }} />
        </FormItem>
        {
          country?.value === CountryEnum.China &&
          <FormItem required label={t('modals.freeTrialModal.applyBox.city')} error={formError.find(e => e.key === 'city')?.error} errorMsg={formError.find(e => e.key === 'city')?.msg}>
            <AInput testId='free-trial-city-input' placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheCity')} value={city} onChange={e => {
              setCity(e.target.value)
            }}
            />
          </FormItem>
        }
      </FormRow> */}
    </div>
    <div className={styles.btnBox}>
      <AButton testId='free-trial-submit-btn' className={styles.btn} type='primary' size='LG' onClick={handleSubmit}>
        <span>{t('modals.freeTrialModal.applyBox.submit')}</span>
        <AIcon type='icon-line-global_arrow'></AIcon>
      </AButton>
    </div>
    <p className={styles.tip}>{t('modals.freeTrialModal.applyBox.tip')}</p>
  </div>
}





export default observer(ApplyTrialBox)
